module.exports = __webpack_public_path__ + "static/media/search_grey.6d320091.svg";